import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";
import { Container } from "manifest-components/src/Containers";
import { ColorVariables } from "manifest-components/src/Colors";
import { Cross } from "manifest-components/src/Images/icons";
import { VersionContext } from "../context/Version/versionProvider";
import { isProdEnvironment } from "../env";

const CONTAINER_HEIGHT = "60px"; // Standarizes the animation offset and the container height

const flyIn = keyframes`
  from {
    transform: translate(0, -${CONTAINER_HEIGHT});
  }

  to {
    transform: translate(0, 0);
  }
`;

const FixedContainer = styled(Container)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: ${CONTAINER_HEIGHT};
  background: ${ColorVariables.coco};
  color: ${ColorVariables.sugar};
  display: flex;
  justify-content: center;
  align-items: center;
  animation-name: ${flyIn};
  animation-timing-function: ease-in;
  animation-duration: 300ms;
`;

const ReloadLink = styled.span`
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const DismissIcon: React.FC<{ onDismiss: () => void }> = ({ onDismiss }) => {
  const Wrapper = styled.div`
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
  `;

  return (
    <Wrapper onClick={onDismiss} role="button">
      <Cross color={ColorVariables.sugar} />
    </Wrapper>
  );
};

export default function VersionNotifier() {
  const { currentVersion, hasNewVersion, firstTimeLoading, dismissVersionNotifier } = useContext(VersionContext);

  // If this is not in a valid environment, quickly exit out of this display
  if (isProdEnvironment()) {
    return null;
  }
  if (!hasNewVersion || firstTimeLoading) return null;

  /** Called when the user clicks the link to reload the page */
  function onRequestReload() {
    window.location.reload();
  }

  return (
    <FixedContainer>
      <DismissIcon onDismiss={() => dismissVersionNotifier()} />
      <p className="small">
        Version {currentVersion} is out!{" "}
        <ReloadLink onClick={() => onRequestReload()}>Please reload the page</ReloadLink>
      </p>
    </FixedContainer>
  );
}
